import { useContext } from 'react';
import { SourceContext } from '../../utils/sourceContext';
import Header from '../.shared/header/header';
import Footer from '../.shared/footer/footer';
import Steps from './Steps';
import FeaturedIn from './FeaturedIn';
import Support from './Support';
import SuccessStories from './SuccessStories';
import NewHero from './NewHero';
import OriginalHero from './OriginalHero';
import LegitScriptBanner from '../.shared/LegitScriptBanner/LegitScriptBanner';

function Landing() {
    const { source, safeSource, switchAndSave } = useContext(SourceContext);
    
    return (
        <>
            <Header hideNavigation={source !== 'tb2'}/>
            {source === 'tb2' ? <NewHero /> : <OriginalHero safeSource={safeSource} switchAndSaveSource={switchAndSave} />}
            <FeaturedIn safeSource={safeSource} />
            <Steps switchAndSaveSource={switchAndSave} />
            <Support />
            <SuccessStories safeSource={safeSource} />
            <LegitScriptBanner />
            <Footer />
        </>
    );
}

export default Landing;
